import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Page, PageHeader } from '#pie/components/page/Page';
import { PageHead } from '#pie/components/page-head/PageHead';
import { Stack } from '#pie/components/stack/Stack';
import { SupportCard } from '#pie/components/support-card/SupportCard';

export const Support = () => {
  const { t } = useTranslation();
  const { t: thl } = useTranslation('hyperlinks');
  const navigate = useNavigate();

  return (
    <>
      <PageHead title={t('support.title')} />
      <Page>
        <PageHeader
          title={t('support.title')}
          previousText={t('common.previous_page')}
          backHref={'...'}
          backOnClick={() => {
            if (window.history.length > 1) {
              navigate(-1);
            } else {
              navigate('/');
            }
          }}
        />
      </Page>
      <Stack
        gap="md"
        className="mx-6 grid grid-cols-2 gap-6 lg:grid-cols-3 justify-between"
      >
        <SupportCard
          heading={t('support.card.malfunction.heading')}
          description={t('support.card.malfunction.description')}
          buttonText={t('support.card.malfunction.heading')}
          href={thl('support.malfunction')}
          buttonType="button"
        />
        <SupportCard
          heading={t('support.card.feedback.heading')}
          description={t('support.card.feedback.description')}
          buttonText={t('ideas.new.description.button')}
          href={thl('support.feedback')}
          buttonType="button"
        />
        <SupportCard
          heading={t('support.card.common_question.heading')}
          description={t('support.card.common_question.description')}
          buttonText="servicedesk@edsn.nl"
          href="mailto:servicedesk@edsn.nl?subject=Algemene vraag of hulp nodig"
          buttonType="link"
        />
        <SupportCard
          heading={t('support.card.datarequest.heading')}
          description={t('support.card.datarequest.description')}
          buttonText="centraaldataloket@partnersinenergie.nl"
          href="mailto:centraaldataloket@partnersinenergie.nl?subject=Vraag over dataverzoek"
          buttonType="link"
        />
        <SupportCard
          heading={t('support.card.collaboration.heading')}
          description={t('support.card.collaboration.description')}
          buttonText="relatiemanagers@partnersinenergie.nl"
          href="mailto:relatiemanagers@partnersinenergie.nl?subject=Vraag over samenwerking in de energiesector"
          buttonType="link"
        />
        <SupportCard
          heading={t('support.card.manual.heading')}
          description={t('support.card.manual.description')}
          buttonText={t('support.card.manual.description.link')}
          href={thl('support.manual')}
          target="_blank"
        />
      </Stack>
    </>
  );
};
